import type { CalendarEvent } from '../../types'
import {
  formatDateLong,
  formatTime,
  parseLocalDateTime,
} from '../../utils/dateUtils'

interface DayViewProps {
  day: Date
  events: CalendarEvent[]
  onSelectEvent: (e: CalendarEvent) => void
  onAdd: () => void
}

const HOURS = Array.from({ length: 24 }, (_, i) => i)

export function DayView({ day, events, onSelectEvent, onAdd }: DayViewProps) {
  return (
    <div className="day-view">
      <div className="day-view__headline">
        <h3>{formatDateLong(day)}</h3>
        <button type="button" className="neon-btn neon-btn--primary" onClick={onAdd}>
          + Termin
        </button>
      </div>

      <div className="day-view__body">
        <div className="day-view__hours">
          {HOURS.map((h) => (
            <div key={h} className="day-view__hour">
              {String(h).padStart(2, '0')}:00
            </div>
          ))}
        </div>
        <div className="day-view__track">
          {HOURS.map((h) => (
            <div key={h} className="day-view__slot" />
          ))}
          {events.map((e) => {
            const start = parseLocalDateTime(e.start)
            const end = parseLocalDateTime(e.end)
            const top =
              ((start.getHours() * 60 + start.getMinutes()) / (24 * 60)) * 100
            const durationMin = Math.max(
              30,
              (end.getTime() - start.getTime()) / 60000,
            )
            const height = (durationMin / (24 * 60)) * 100
            return (
              <button
                key={e.id}
                type="button"
                className="day-event"
                style={{
                  top: `${top}%`,
                  height: `${Math.min(height, 100 - top)}%`,
                  background: `${e.color}22`,
                  borderColor: e.color,
                }}
                onClick={() => onSelectEvent(e)}
              >
                <span className="day-event__time" style={{ color: e.color }}>
                  {formatTime(e.start)} – {formatTime(e.end)}
                </span>
                <strong>{e.title}</strong>
                {e.notes && <p className="day-event__notes">{e.notes}</p>}
              </button>
            )
          })}
          {events.length === 0 && (
            <div className="day-view__empty">
              Keine Termine an diesem Tag.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
